var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchHover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 34,
    height: 34,
    transform: "translate(725 137)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    transform: "translate(-725 -137)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_search_",
    "data-name": "FontAwsome (search)",
    d: "M25.188,22.081l-4.973-4.973a1.2,1.2,0,0,0-.848-.349h-.813a10.37,10.37,0,1,0-1.8,1.8v.813a1.2,1.2,0,0,0,.349.848l4.973,4.973a1.192,1.192,0,0,0,1.691,0l1.412-1.412A1.2,1.2,0,0,0,25.188,22.081ZM10.374,16.759a6.384,6.384,0,1,1,6.384-6.384A6.381,6.381,0,0,1,10.374,16.759Z",
    transform: "translate(729 141)",
    fill: "#7ba532"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchHover);
export default __webpack_public_path__ + "static/media/icon_search_hover.b791613fe5974974290b2ab294cdd2c4.svg";
export { ForwardRef as ReactComponent };